export default "__VITE_ASSET__D5H_cQmZ__"